<template>
<loader v-bind="{ loading }">
  <div class="app-dashboard">
    <div class="columns">
      <div class="column">
        <h2 class="env-name">
          Viewing <span class="has-text-weight-bold">
            <router-link :to="{
              name: 'environment-manager',
              params: {
                environment: dashboard.environment.id
              }
            }">{{ dashboard.environment.name }}</router-link>
          </span>
        </h2>
      </div>
      <div class="column is-narrow">
        <div class="is-flex align-center">
          <a @click="changeEnv">change</a>
          <span class="tag ml-1" :class="{
            'is-success': dashboard.environment.is_production,
            'is-warning': !dashboard.environment.is_production,
          }" v-text="dashboard.environment.is_production ? 'Production' : 'Development'"></span>
        </div>
      </div>
    </div>

    <columns>
      <column>
        <environment-dashboard v-if="dashboard.environment && dashboard.environment.id" :environment-id="dashboard.environment.id"/>  
      </column>
      <column class="is-3">
        <p>Environments ({{ dashboard.environments.length }})</p>
        <router-link :to="{
              name: 'environment-manager',
              params: {
                environment: environment.id
              }
            }" class="is-flex justify-between" v-for="environment in dashboard.environments" :key="environment.id">
          <span>{{ environment.name }}</span>
          <span :class="{
            'has-text-danger': environment.unresolved_findings_count > 0
          }">{{ environment.unresolved_findings_count }}</span>
        </router-link>
      </column>
    </columns>
  </div>
</loader>
</template>

<script>
import { mapGetters } from 'vuex'
import { startCase, find } from 'lodash'
import RouteDonut from './dashboard/RouteDonut'
import IdorChart from './dashboard/IdorChart'
import EnvironmentDashboard from '@/views/apps/Environment/partials/overview/Dashboard'
import { selectEnvironment } from '@/modals'

export default {

  components: {
    RouteDonut,
    IdorChart,
    EnvironmentDashboard
  },

  data: () => ({
    showMonitorWarning: false,
    loading: true,
  }),

  beforeCreate() {
    this.$store.dispatch('app/loadDashboard', this.$route.params.app).then(data => {
      this.$store.commit('environment/setEnvironment', data.environment)
      this.loading = false
    })
  },

  created() {
    if (!localStorage.getItem('monitor_warning')) {
      this.showMonitorWarning = true
    }
  },

  methods: {
    dontShowMonitorWarning() {
      this.showMonitorWarning = false
      localStorage.setItem('monitor_warning', 'dont_show')
    },
    ucWords(value) {
      return startCase(value)
    },
    changeEnv() {
      selectEnvironment(this.dashboard.environments).then(envId => {
        if(envId) {
          this.$bus.$emit('load-environment-dashboard', envId)
          this.$store.dispatch('app/setDashboardEnv', envId)
        }
      })
    }
  },

  computed: {
    ...mapGetters('app', [
      'app',
      'dashboard'
    ]),
    productionIsSetup() {
      return this.dashboard.environments.filter(env => env.is_production && env.attributes.length).length > 0
    },
    software() {
      return this.dashboard.environment.software
    },
    laravelVersion() {
      return find(
        this.dashboard.environment.software, 
        { cpe_identifier: 'laravel:laravel' }
      )
    },
    configVulnerabilities() {
      return this.dashboard.attribute_vulnerabilities.filter(vulnerability => vulnerability.findable.type.type === 'config')
    },
    environmentVulnerabilities() {
      return this.dashboard.attribute_vulnerabilities.filter(vulnerability => vulnerability.findable.type.type === 'environment')
    }
  }
}
</script>
